import React from "react";
import { selectTranslations } from "../../../config/i18n/slice";
import { Divider, Image, Icon, List, Header } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Country, State } from "country-state-city";
import UserProfilePlaceholder, {
  LetteredAvatarImageUrl,
} from "../../../components/common/userProfilePlaceholder";

const SubLocations = ({ data, negative }) => {
  const history = useHistory();

  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  let subLocations = data?.attributes?.subLocations?.data;
  if (subLocations.length > 0) {
    subLocations = subLocations.map((sub, index) => {
      const subCitiesOfCountry = State.getStatesOfCountry(
        sub.attributes.country
      );
      const sub_city = sub?.attributes?.city
        ? subCitiesOfCountry.filter((city) => {
            return city.isoCode == sub?.attributes?.city;
          })[0]?.name
        : t.common.na;

      let createdByUserSub = sub.attributes.createdByUser?.data?.attributes ? (
        <div>
          <Image className="sub-locations"
            avatar
            title={
              sub.attributes.createdByUser?.data?.attributes.firstName +
              " " +
              sub.attributes.createdByUser?.data?.attributes.lastName
            }
            src={
              sub.attributes.createdByUser?.data?.attributes?.profileImage?.data
                ?.attributes?.url
                ? sub.attributes.createdByUser?.data?.attributes?.profileImage
                    ?.data?.attributes?.url
                : LetteredAvatarImageUrl(
                    sub.attributes.createdByUser?.data?.attributes.firstName +
                      " " +
                      sub.attributes.createdByUser?.data?.attributes.lastName
                  )
            }
            // style={{ width: "20px", height: "20px" }}
          />
          <span className="ml-1">
            {sub.attributes.createdByUser?.data?.attributes.firstName}
          </span>
        </div>
      ) : (
        t.common.na
      );

      let subCustomers = sub.attributes?.customers?.data;
      if (subCustomers?.length > 0) {
        subCustomers = subCustomers.map((people, index) => {
          if (people?.attributes?.logo?.data?.attributes?.url) {
            return (
              <div
                className="d-flex mt-2"
                onClick={() =>
                  history.push(`/customers?id=${people.attributes?.countId}`)
                }
              >
                <Image
                  key={index}
                  className="customer-image"
                  avatar
                  title={people.attributes.name + " " + " "}
                  src={`${people?.attributes?.logo?.data?.attributes?.url}`}
                  // style={
                  //   index !== 0
                  //     ? { marginLeft: "-6px", width: "34px", height: "34px" }
                  //     : { width: "34px", height: "34px" }
                  // }
                />

                <div
                  className="work-order-link mt-1 ml-1"
                  basic
            
                >
                  {people?.attributes?.name}
                  <Icon name="angle right" />
                </div>
              </div>
            );
          } else {
            return (
              <div
                className="d-flex mt-2"
                onClick={() =>
                  history.push(`/customers?id=${people?.attributes?.countId}`)
                }
              >
                <UserProfilePlaceholder
                  key={index}
                  name={`${
                    people?.attributes?.name ? people?.attributes?.name : ""
                  } ${""}`}
                  width={"34px"}
                  height={"34px"}
                />
                <div
                  className="work-order-link ml-1 mt-1"
                  basic
                  
                >
                  {people?.attributes?.name}
                  <Icon name="angle right" />
                </div>
              </div>
            );
          }
        });
      } else {
        subCustomers = t.common.na;
      }

      let subVendors = sub?.attributes.vendors?.data;
      if (subVendors?.length > 0) {
        subVendors = subVendors.map((people, index) => {
          if (people?.attributes?.logo?.data?.attributes?.url) {
            return (
              <div
                className="d-flex mt-2"
                onClick={() =>
                  history.push(`/vendors?id=${people?.attributes?.countId}`)
                }
              >
                <Image
                  key={index}
                  avatar
                    className="customer-image"
                  title={people.attributes.name + " " + " "}
                  src={`${people?.attributes?.logo?.data?.attributes?.url}`}
                  // style={
                  //   index !== 0
                  //     ? { marginLeft: "-6px", width: "34px", height: "34px" }
                  //     : { width: "34px", height: "34px" }
                  // }
                />

                <div
                  className="work-order-link ml-1 mt-1"
                  basic
               
                >
                  {people?.attributes?.name}
                  <Icon name="angle right" />
                </div>
              </div>
            );
          } else {
            return (
              <div
                className="d-flex mt-2"
                onClick={() =>
                  history.push(`/vendors?id=${people?.attributes?.countId}`)
                }
              >
                <UserProfilePlaceholder
                  key={index}
                  name={`${
                    people?.attributes?.name ? people?.attributes?.name : ""
                  } ${""}`}
                  width={"34px"}
                  height={"34px"}
                />
                <div
                  className="work-order-link mt-1 ml-1"
                  basic
          
                >
                  {people?.attributes?.name}
                  <Icon name="angle right" />
                </div>
              </div>
            );
          }
        });
      } else {
        subVendors = t.common.na;
      }

      let customFields = sub?.attributes?.customFields;

      if (customFields.length > 0) {
        customFields = customFields.map((el, index) => {
          return (
            <>
              <div className="d-flex align-items-center mt-5">
                <label className="detail-intro-label location-label1">
                  {t.locations.form.label} {index + 1}
                  {":"}
                </label>
                <p className="detail-intro-value">
                  {el?.label ? el.label : t.common.na}
                </p>
              </div>

              <div className="d-flex align-items-center mt-5">
                <label className="detail-intro-label location-label1">
                  {t.locations.form.value} {index + 1}
                  {":"}
                </label>
                <p className="detail-intro-value">
                  {el?.value ? el.value : t.common.na}
                </p>
              </div>
            </>
          );
        });
      } else {
        customFields = "";
      }

      let area = sub?.attributes?.areas?.data;
      let areaString = "";
      if (area?.length > 0) {
        areaString = area.map((people) => people?.attributes?.name).join(", ");
      } else {
        areaString = t.common.na;
      }

      return (
        <>
          <h3>{sub?.attributes.name}</h3>
          <div className="detail-intro">
            <div className="d-flex align-items-center mt-5">
              <label className="detail-intro-label location-label1">
                {t.locations.table.country}
                {":"}
              </label>
              <p className="detail-intro-value">
                {sub?.attributes?.country
                  ? Country.getCountryByCode(sub?.attributes?.country)?.name
                  : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="detail-intro-label location-label1">
                {t.locations.table.city}
                {":"}
              </label>
              <p className="detail-intro-value"> {sub?.attributes?.city
                            ? State.getStateByCodeAndCountry(
                              sub?.attributes?.city,
                              sub?.attributes?.country
                              )?.name
                              ? State.getStateByCodeAndCountry(
                                sub?.attributes?.city,
                                sub?.attributes?.country
                                )?.name
                              : sub?.attributes?.cityName
                              ? sub?.attributes?.cityName
                              : t.common.na
                            : t.common.na}</p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="detail-intro-label location-label1">
                {t.locations.table.address}
                {":"}
              </label>
              <p className="detail-intro-value">
                {sub.attributes.address ? sub.attributes.address : t.common.na}
              </p>
            </div>

            <div className="d-flex align-items-center mt-5">
              <label className="detail-intro-label location-label1">
                {t.assets.form.area}
                {":"}
              </label>
              <p className="detail-intro-value">{areaString}</p>
            </div>

            {customFields.length > 0 ? customFields : null}

            <div className="d-flex align-items-center customer-container mt-5">
              <label className="detail-intro-label location-label1">
                {t.locations.table.customer}
                {":"}
              </label>
              <p className="detail-intro-value">
                {subCustomers ? subCustomers : t.common.na}
              </p>
            </div>
            <div className="d-flex align-items-center mt-5">
              <label className="detail-intro-label location-label1">
                {t.locations.form.vendors}
                {":"}
              </label>
              <p className="detail-intro-value">
                {subVendors ? subVendors : t.common.na}
              </p>
            </div>
          </div>
          <Divider />
        </>
      );
    });
  } else {
    subLocations = "";
  }


  return (
    <div className="preview-details-wrapper">
      {subLocations.length > 0 ? (
        subLocations
      ) : (
        <>
          {" "}
          <div className="text-center">
            <Header as="h3">{t.common.na}</Header>
          </div>
        </>
      )}
    </div>
  );
};

export default SubLocations;
